(function () {
  'use strict';

  angular
    .module('acUtilizationReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('acUtilizationReport', {
        url: '/ac-utilization-report',
        views : {
        	'acUtilizationReportView' : {
        		templateUrl: 'ac-utilization-report/views/ac-utilization-report.tpl.html',
                controller: 'AcUtilizationReportCtrl',
                controllerAs: 'acUtilizationReport'
        	}
        }
      });
  }
}());
